import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { getSafeEnvName } from "@faire/retailer-visitor-shared/serialized-data/getEnvName";
import { TOSType, TOS_ZENDESK_ARTICLE_IDS } from "@faire/retailer-visitor-shared/views/terms-of-services/data/consts";
import { getBrandTOSArticleData } from "@faire/retailer-visitor-shared/views/terms-of-services/data/getBrandTOSArticleData";
import { getFairePayTOSArticleData } from "@faire/retailer-visitor-shared/views/terms-of-services/data/getFairePayTOSArticleData";
import { getInsiderTOSArticleData } from "@faire/retailer-visitor-shared/views/terms-of-services/data/getInsiderTOSArticleData";
import { getMainTOSArticleData } from "@faire/retailer-visitor-shared/views/terms-of-services/data/getMainTOSArticleData";
import { getOwfGrantTOSArticleData } from "@faire/retailer-visitor-shared/views/terms-of-services/data/getOwfGrantTOSArticleData";
import { getRetailerTOSArticleData } from "@faire/retailer-visitor-shared/views/terms-of-services/data/getRetailerTOSArticleData";
import { exhaustiveSwitchWithDefault } from "@faire/web--source/common/exhaustiveSwitchWithDefault";
export var chooseArticleId = function(tosType, tosCountryType) {
    return TOS_ZENDESK_ARTICLE_IDS[tosType][getSafeEnvName()][tosCountryType];
};
export var getZendeskArticleData = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(tosType) {
        return _ts_generator(this, function(_state) {
            switch(tosType){
                case TOSType.MAIN:
                    return [
                        2,
                        getMainTOSArticleData()
                    ];
                case TOSType.RETAILER:
                    return [
                        2,
                        getRetailerTOSArticleData()
                    ];
                case TOSType.BRAND:
                    return [
                        2,
                        getBrandTOSArticleData()
                    ];
                case TOSType.INSIDER:
                    return [
                        2,
                        getInsiderTOSArticleData()
                    ];
                case TOSType.FAIRE_PAY:
                    return [
                        2,
                        getFairePayTOSArticleData()
                    ];
                case TOSType.OWF_GRANT:
                    return [
                        2,
                        getOwfGrantTOSArticleData()
                    ];
                default:
                    return [
                        2,
                        exhaustiveSwitchWithDefault(getMainTOSArticleData())(tosType)
                    ];
            }
            return [
                2
            ];
        });
    });
    return function getZendeskArticleData(tosType) {
        return _ref.apply(this, arguments);
    };
}();
